export const args = {
    data: [
        {
            id: 1,
            value: 'Bengaluru'
        },
        {
            id: 1,
            value: 'Delhi'
        },
        {
            id: 1,
            value: 'Mumbai'
        },
        {
            id: 1,
            value: 'Indore'
        },
    ],
    searchString: ''
};
export const argTypes = {};
